import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "8.5 5 6 11",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.494 8.217 C 7.303 8.262,7.050 8.477,6.962 8.670 C 6.876 8.861,6.876 9.144,6.964 9.337 C 7.018 9.456,7.476 9.892,9.057 11.330 C 10.316 12.475,11.138 13.196,11.233 13.239 C 11.427 13.327,11.673 13.327,11.867 13.239 C 11.962 13.196,12.784 12.475,14.043 11.330 C 15.624 9.892,16.082 9.456,16.136 9.337 C 16.418 8.715,15.827 8.035,15.171 8.228 C 14.996 8.279,14.824 8.425,13.264 9.844 L 11.550 11.404 9.854 9.860 C 8.921 9.010,8.106 8.293,8.043 8.265 C 7.878 8.194,7.669 8.176,7.494 8.217 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretDown;
